<template>
  <DataList
    title="Оплати"
    resource="payments"
    :columns="columns"
    :filter="filter"
    :get-items-fn="getPayments"
    :search-label="'Пошук за назвою платника клієнта'"
    @search="onSearchChange"
    @load="onLoad"
  >
    <template v-slot:action-buttons>
      <DownloadFile
        :location="`payments/rpc/export-to-excel?${filterParams}`"
        filename="Оплати"
        extension="xlsx"
        tooltip="Завантажити у форматі Excel"
      />
    </template>
    <template v-slot:filters>
      <v-row
        dense
        justify="center"
      >
        <v-col cols="3">
          <DateRangePicker
            :start.sync="dateFrom"
            :end.sync="dateTo"
            :filled="false"
          />
        </v-col>
        <v-col>
          <ManagerSelect v-model="manager" />
        </v-col>
        <v-col>
          <EnumSelect
            v-model="rolePaymentType"
            clearable
            :items="paymentTypes"
            label="Тип Оплати"
            placeholder="Виберіть тип оплати"
          />
        </v-col>
        <v-col>
          <PaymentSourceSelect
            v-model="paymentSource"
            placeholder="Найменування джерела"
          />
        </v-col>
      </v-row>
    </template>
    <template v-slot:totals>
      <v-row no-gutters>
        <v-spacer />
        <v-col cols="3">
          <v-menu
            :disabled="totalAmount === 0"
            :nudge-bottom="40"
            open-on-hover
            right
          >
            <template v-slot:activator="{ on }">
              <v-row
                no-gutters
                v-on="on"
              >
                <v-col class="d-flex align-center">
                  <v-card-text class="subtitle-1 text-right pa-0">
                    Сумма:&nbsp;
                  </v-card-text>
                  <v-card-text class="title text-right pa-0">
                    {{ totalAmount | decimal }}
                  </v-card-text>
                </v-col>
              </v-row>
            </template>
            <v-card>
              <v-list>
                <v-list-item
                  v-for="(managerPayments, index) in paymentsByManagers"
                  :key="index"
                >
                  <v-list-item-content>{{ managerPayments.manager ? managerPayments.manager.title : "Без менеджера" }}</v-list-item-content>
                  <v-list-item-action>{{ managerPayments.amount | decimal }}</v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
        </v-col>
      </v-row>
    </template>
  </DataList>
</template>

<script>
import PaymentSourceSelect from "../../catalogs/payment-sources/PaymentSourceSelect.vue";
import DownloadFile from "../../../components/DowloadFile.vue";
import DateRangePicker from "@/components/story/DateRangePicker";
import ManagerSelect from "../../catalogs/managers/ManagerSelect.vue";
import EnumSelect from "@/components/selects/EnumSelect";
import * as managerApi from "../../../backend/managersApi.js";
import * as paymentsApi from "../../../backend/paymentsApi.js";
import * as sourcesApi from "../../../backend/sourcesApi.js";
import paymentTypes from "../../../helpers/paymentTypes.js";

export default {
  components: {
    PaymentSourceSelect,
    DownloadFile,
    ManagerSelect,
    DateRangePicker,
    EnumSelect,
  },
  data: () => ({
    columns: [
      { title: "id", name: "id", dataPath: "id" },
      { title: "Дата", name: "date", dataPath: "date" },
      { title: "Тип", name: "paymentType", dataPath: "paymentType.title" },
      { title: "Клієнт", name: "client", dataPath: "client.title", rowType: "wide" },
      { title: "Години", name: "hours", dataPath: "hours", type: "decimal" },
      { title: "Сума", name: "amount", dataPath: "amount" },
      {
        title: "Менеджер",
        name: "manager",
        dataPath: "manager.title",
        rowType: "wide",
      },
    ],
    dateFromMenu: false,
    dateFrom: "",
    dateTo: "",
    dateToMenu: false,
    rolePaymentType: null,
    paymentType: null,
    paymentTypeVariants: [],
    paymentSource: null,
    totalAmount: 0,
    search: null,
    manager: null,
    dates: [],
    paymentsByManagers: [],
  }),
  computed: {
    filter() {
      return {
        dateFrom: this.dateFrom || "",
        dateTo: this.dateTo || "",
        paymentType: {
          id: this.paymentType?.value ?? "",
          title: this.paymentType?.text || "",
        },
        paymentSource: {
          id: this.paymentSource?.id || "",
          title: this.paymentSource?.title || "",
        },
        manager: {
          id: this.manager?.id || "",
          title: this.manager?.title || "",
        },
      };
    },
    filterParams() {
      return `filter.dateFrom=${this.filter?.dateFrom ?? ""}
              &filter.dateTo=${this.filter?.dateTo ?? ""}
              &filter.paymentType=${this.filter?.paymentType?.id ?? ""}
              &filter.paymentSourceId=${this.filter?.paymentSource?.id ?? ""}
              &filter.managerId=${this.filter?.manager?.id ?? ""}`;
    },
    paymentTypes(){
      return [
        {
          value: paymentTypes.BANK.value,
          text: paymentTypes.BANK.title,
        },
        {
          value: paymentTypes.CARD.value,
          text: paymentTypes.CARD.title,
        },
        {
          value: paymentTypes.CASH.value,
          text: paymentTypes.CASH.title,
        },
      ];
    },
  },
  watch: {
    filter: {
      handler() {
        this.getTotalAmount();
      },
    },
    rolePaymentType(val) {
      this.paymentType = this.paymentTypes.find(
        (el) => el.value === val
      );
    },
  },
  created() {
    this.getTotalAmount();
    this.getManager();
    this.getPaymentSource();
    this.initPaymentType();

    const { dateFrom, dateTo } = this.$router.currentRoute.query;
    if (dateFrom && dateTo) {
      this.dateFrom = dateFrom;
      this.dateTo = dateTo;
    }
  },
  methods: {
    getTotalAmount() {
      paymentsApi
        .totalPaymentAmount(this.filter, this.search)
        .then((totalAmount) => {
          this.totalAmount = totalAmount;
        });
    },
    onSearchChange(searchTerm) {
      this.search = searchTerm;
      this.getTotalAmount();
    },
    getPayments(...args) {
      return paymentsApi.getPayments(args[0], args[1], args[2], args[3]);
    },
    async getManager() {
      const managerId = this.$router.currentRoute.query.managerId;
      if (!managerId) {
        return;
      }
      const result = await managerApi.getManager(managerId);
      try {
        return (this.manager = {
          id: result.id,
          title: result.title,
        });
      } catch (error) {
        console.log(error);
      }
    },
    initPaymentType() {
      const paymentTypeId = this.$router.currentRoute.query.paymentTypeId;
      if (!paymentTypeId) {
        return;
      }

      const item = this.paymentTypes.find((i) => i.id === +paymentTypeId);
      try {
        return (this.paymentType = {
          id: item.id,
          title: item.title,
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getPaymentSource() {
      const paymentSourceId = this.$router.currentRoute.query.paymentSourceId;
      if (!paymentSourceId) {
        return;
      }
      const result = await sourcesApi.getPaymentSource(paymentSourceId);
      try {
        return (this.paymentSource = {
          id: result.id,
          title: result.title,
        });
      } catch (error) {
        console.log(error);
      }
    },
    onLoad(page) {
      this.paymentsByManagers = page.paymentsByManagers;
      this.paymentsByManagers.sort((a, b) => b.amount - a.amount);
    },
  },
};
</script>
